export default {
  methods: {
    hasPermission (store, str) {
      return store.getters['authentication/permissions'].includes(str)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/Permissions.js